import React from 'react';
import { Link } from 'react-router-dom';
import PageHero from '../components/PageHero';
import { useContent } from '../content/ContentContext';
import { useUi } from '../i18n/ui';
import { renderMultiline } from '../utils/text';
import SocialLinks from '../components/SocialLinks';

const Contatti: React.FC = () => {
  const { t, img } = useContent();
  const { tr } = useUi();
  const phone = t('contact.phone', '+393467814537');
  const email = t('contact.email', 'info@insolitasardegna.com');

  return (
    <>
      <PageHero image={img('contatti.hero.image', '/img/insolita-sardegna-moto.jpg')} crumb={tr('page.contatti.title')} title={tr('page.contatti.title')} minHeight="46svh" />

      <section className="sec">
        <div className="wrap">
          <div className="contact-grid">
            <div className="reveal">
              <span className="eyebrow">{t('contatti.eyebrow', 'Parliamone')}</span>
              <h2 className="h-sec" style={{ margin: '.35em 0 .4em' }}>{renderMultiline(t('contatti.title', 'Scrivici,\nchiamaci'))}</h2>
              <p className="lead" style={{ marginBottom: 10 }}>{t('contatti.lead', 'Per informazioni sui tour, sul tesseramento o sul Sardegna Rally Raid, siamo a tua disposizione.')}</p>
              <div className="contact-list">
                <div className="row"><div className="k">Sede</div><div className="v">{t('contact.sede', 'Olbia — Via Vincenzo Piro')}</div></div>
                <div className="row"><div className="k">Telefono</div><div className="v"><a href={`tel:${phone}`}>(+39) {phone.replace('+39', '')}</a></div></div>
                <div className="row"><div className="k">Email</div><div className="v"><a href={`mailto:${email}`}>{email}</a></div></div>
                <div className="row"><div className="k">Orari</div><div className="v">{t('contact.hours', 'Lun — Sab · 9:00—18:00')}</div></div>
              </div>
              <div className="hero__cta" style={{ marginTop: 34 }}>
                <a href={`mailto:${email}`} className="btn btn-acid">{t('contatti.cta.email', 'Invia una email')}</a>
                <Link to="/iscrizioni" className="btn btn-ghost-ink">{t('contatti.cta.tesseramento', 'Vai al tesseramento')}</Link>
              </div>
            </div>
            <div className="reveal" data-d="1">
              <div className="map-frame">
                <iframe title="Mappa Olbia" loading="lazy" src="https://www.openstreetmap.org/export/embed.html?bbox=9.47%2C40.90%2C9.53%2C40.94&layer=mapnik&marker=40.9236%2C9.4986" />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="band">
        <div className="band__topo" style={{ backgroundImage: `url('${img('contatti.cta.image', '/img/insolita-sardegna-moto.jpg')}')` }} />
        <span className="eyebrow on-dark" style={{ position: 'relative' }}>{t('contatti.band.eyebrow', 'Seguici sui social')}</span>
        <h2 style={{ marginTop: '.4em' }}>{renderMultiline(t('contatti.band.title', 'Resta in\nsella con noi'))}</h2>
        <SocialLinks style={{ justifyContent: 'center', marginTop: 32, position: 'relative' }} />
      </section>
    </>
  );
};

export default Contatti;
